<template>
  <div id="app">
    <v-app class="position-relative">
      <v-tooltip
        :disabled="$vuetify.breakpoint.xs"
        content-class="arrow-left"
        color="#DCD8F3"
        right
        open-delay="300"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-show="breakpoint == 'lg' || breakpoint == 'xl'"
            class="toggler"
            @click="toggleMini"
            fab
          >
            <v-icon color="white">{{
              mini ? "mdi-chevron-right" : "mdi-chevron-left"
            }}</v-icon>
          </v-btn>
        </template>
        <span class="dark-purple-text font-weight-bold">{{
          mini ? "Expand" : "Minimize"
        }}</span>
      </v-tooltip>

      <v-navigation-drawer
        v-if="!isExtension"
        disable-route-watcher
        :permanent="!$vuetify.breakpoint.xs"
        :temporary="!isExtension && $vuetify.breakpoint.xs"
        :mini-variant="mini"
        v-model="drawer"
        :close-on-content-click="$vuetify.breakpoint.xs ? true : false"
        app
        :style="$vuetify.breakpoint.xs ? 'margin-top: 60px' : '0px'"
        :height="$vuetify.breakpoint.xs ? 'calc(100vh - 45px)' : '100vh'"
      >
        <v-card
          dark
          class="rounded-0 h-100 overflow-hidden left-pannel-bg-color"
        >
          <v-list-item v-if="!$vuetify.breakpoint.xs" class="px-1">
            <!-- Product Logo -->
            <div class="white--text">
              <img
                src="@/assets/images/logo-copy.svg"
                height="40px"
                class="mt-4 ml-2"
              />
            </div>
          </v-list-item>
          <!------Render Left Pannel List---->
          <div
            id="sidebar-list"
            class="
              mt-6
              pointer
              max-height-sidebar
              overflow-y-auto overflow-x-hidden
            "
          >
            <div
              :class="[
                title == link.text ? 'selected-route' : '',
                getSelectedCompany.role == 'employee' ? 'd-none' : '',
                !getOnlineStatus ? 'dusty-purple-text disable-cursor ' : '',
                link.text == 'Create Task' ? 'd-none' : '',
              ]"
              class="d-flex align-center pl-4"
              id="left-nav-listitem"
              v-for="(link, i) in !$vuetify.breakpoint.xs
                ? links.filter((item) => {
                    return item.text != 'Create Task';
                  })
                : links"
              :key="i"
              @click="getPendingTimer || getOnlineStatus ? redirect(link) : ''"
              :disabled="
                getPendingTimer || getOnlineStatus == false ? true : false
              "
            >
              <!-- Sidebar Icons -->
              <div :id="link.icon">
                <v-icon
                  :class="
                    !getOnlineStatus ? 'dusty-purple-text disable-cursor' : ''
                  "
                  class="mr-7 py-4"
                  v-text="link.icon"
                  size="25"
                ></v-icon>
              </div>
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-left"
                v-if="getSidebarMini"
                :activator="'#' + link.icon"
                nudge-right="7"
                right
                color="#DCD8F3"
              >
                <span class="dark-purple-text font-weight-bold">
                  {{ link.text }}
                </span>
              </v-tooltip>
              <!-- Sidebar Text -->
              <div v-show="!getSidebarMini || drawer" id="left-nav-list-text">
                <div>
                  <b>
                    {{
                      link.text == "Task Tracker" &&
                      $route.name != "task" &&
                      getTimer &&
                      getActiveTask
                        ? time
                        : link.text
                    }}
                  </b>
                </div>
              </div>
            </div>
            <div
              :disabled="
                getPendingTimer ||
                getOnlineStatus == false ||
                getScreenRecorderState
                  ? true
                  : false
              "
              @click="logout()"
              id="logout"
              class="pointer d-flex align-center py-4 pl-4"
              :class="
                !getOnlineStatus ? 'dusty-purple-text disable-cursor ' : ''
              "
            >
              <div id="logout-icon">
                <v-icon
                  :class="
                    !getOnlineStatus ? 'dusty-purple-text disable-cursor ' : ''
                  "
                  :disabled="
                    getPendingTimer ||
                    getOnlineStatus == false ||
                    getScreenRecorderState
                      ? true
                      : false
                  "
                  size="25"
                  class="mr-7"
                  >mdi-logout</v-icon
                >
              </div>
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-left"
                v-if="getSidebarMini"
                activator="#logout-icon"
                nudge-right="7"
                right
                color="#DCD8F3"
              >
                <span class="dark-purple-text font-weight-bold">
                  {{ "Logout" }}
                </span>
              </v-tooltip>
              <!-- Sidebar Text -->
              <div>
                <div id="logout-text"><b>Log Out </b></div>
              </div>
            </div>
          </div>
          <div
            v-if="$vuetify.breakpoint.xs && !isExtension"
            class="d-flex align-center justify-start ml-3 mt-8"
          >
            <!-- User Profile -->
            <profileimage
              class="pointer text-light mt-2"
              inline
              v-show="getLoggedInUser.image ? ':src' : ':username'"
              :username="getLoggedInUser.name"
              :src="getLoggedInUser.image"
              :userProfile="true"
              :size="$vuetify.breakpoint.xs ? 40 : 50"
              :circular="true"
            ></profileimage>
            <span
              style="max-width: 120px"
              class="mx-2 mt-1 text-truncate text-capitalize"
              >{{
                getLoggedInUser.name
                  ? getLoggedInUser.name
                  : getLoggedInUser.email
              }}</span
            >
            <span class="caption">{{
              getLoggedInUser.designation ? getLoggedInUser.designation : ""
            }}</span>
          </div>
          <!-- Chrome Extension Button -->
          <div class="d-none">
            <v-bottom-navigation
              v-show="!getExtension && !$vuetify.breakpoint.xs"
              class="left-pannel-bg-color"
              absolute
            >
              <div
                :disabled="
                  getPendingTimer ||
                  getOnlineStatus == false ||
                  getScreenRecorderState
                    ? true
                    : false
                "
                @click="extension()"
                class="pointer rounded d-flex align-center justify-center"
                style="background-color: #1cc283; height: 40px"
              >
                <div
                  id="extension-icon"
                  class="px-2 d-flex align-center justify-center"
                >
                  <img src="@/assets/images/chrome-w.svg" />
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="arrow-left"
                    v-if="getSidebarMini"
                    activator="#extension-icon"
                    nudge-right="7"
                    right
                    color="#DCD8F3"
                  >
                    <span class="dark-purple-text font-weight-bold">
                      {{ "For Chrome" }}
                    </span>
                  </v-tooltip>
                  <!-- Sidebar Text -->
                  <div class="ml-3" v-if="!getSidebarMini">
                    Download Extension
                  </div>
                </div>
              </div>
            </v-bottom-navigation>
          </div>
        </v-card>
      </v-navigation-drawer>
      <!-- Top Bar -->
      <v-app-bar
        class="border-0 top-bar-elevation"
        app
        elevation="0"
        :color="$vuetify.breakpoint.xs ? '#302277' : 'white'"
        :height="isExtension ? 42 : $vuetify.breakpoint.xs ? 60 : 46"
        :width="
          $vuetify.breakpoint.xs
            ? ''
            : getSidebarMini
            ? 'calc(100vw - 56px)'
            : 'calc(100vw - 256px)'
        "
      >
        <!-- <div class="red">
          <img src="@/assets/images/dashboard-icon.svg" alt="hello" />
        </div> -->

        <v-app-bar-nav-icon
          v-if="$vuetify.breakpoint.xs && !isExtension"
          @click.stop="toggleDrawer"
          text
          tile
          small
          class="white--text mr-2"
        ></v-app-bar-nav-icon>
        <v-overlay
          :value="!getOnlineStatus"
          v-if="!getOnlineStatus"
          opacity="1"
          color="#FFF5F7"
          class="text-center"
        >
          <span class="red--text text--darken-1 font-weight-bold">
            <v-icon class="red--text text--darken-1">
              mdi-close-circle-outline
            </v-icon>

            Offline Mode !</span
          >
          <span class="black--text"> No internet Connection </span>
        </v-overlay>
        <img
          v-if="!isExtension && $vuetify.breakpoint.xs"
          @click="$router.push({ name: 'mobileTasks' })"
          src="@/assets/images/logo-2.svg"
          height="28px"
          class="ml-0"
        />
        <img
          v-if="isExtension"
          src="@/assets/images/logo-2.svg"
          height="28px"
          class="ml-0"
        />
        <v-toolbar-title
          v-if="!isExtension && !$vuetify.breakpoint.xs"
          class="font-weight-bold app-bar-title"
          >{{
            getReportsView == "user" && title == "Reports"
              ? "Members " + title
              : getReportsView == "leader" && title == "Reports"
              ? "Team Leads " + title
              : getReportsView == "project" && title == "Reports"
              ? "Projects " + title
              : title
          }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <!-- Actions/filters for tasks -->
        <div
          v-if="
            !isExtension &&
            !$vuetify.breakpoint.xs &&
            $route &&
            $route.path.slice(0, 5) == '/task'
          "
          class="d-flex align-center"
        >
          <!-- Title search -->
          <div
            style="height: 32px; min-width: 32px"
            @click="titleField = !titleField"
            class="
              d-flex
              align-center
              bg-white
              justify-center
              ml-2
              rounded
              theme-border
            "
          >
            <v-icon :class="titleField ? 'mx-2' : ''" color="#757096"
              >mdi-magnify</v-icon
            >
            <v-expand-transition>
              <input
                v-show="titleField"
                id="title-search-field"
                v-model="titleSearchQuery"
                placeholder="Search title"
                color="white"
                class="body-2 title-search-field ma-0 pa-0"
                @blur="titleField = false"
                type="text"
                autocomplete="off"
              />
            </v-expand-transition>
          </div>

          <TaskFilters @openSidebar="filtersDrawer = !filtersDrawer" />

          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- Table View -->
              <v-btn
                v-bind="attrs"
                v-on="on"
                text
                min-width="32px"
                height="32px"
                class="theme-border-3 bg-white rounded py-2 px-0"
                @click="listView()"
              >
                <img
                  v-if="getView == 'list'"
                  src="@/assets/images/list-icon-selected.svg"
                  alt="list-view-img"
                  :height="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  :width="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  class="ma-0"
                />
                <img
                  v-else
                  src="@/assets/images/list-icon.svg"
                  alt="list-view-img"
                  :height="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  :width="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  class="ma-0"
                />
              </v-btn>
            </template>
            <span class="font-weight-bold dark-purple-text">List View</span>
          </v-tooltip>

          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- Kanban View -->
              <v-btn
                v-bind="attrs"
                v-on="on"
                text
                min-width="32px"
                height="32px"
                @click="resetFilters(), setKanbanView()"
                class="theme-border-3 bg-white mx-2 py-2 px-0"
              >
                <img
                  v-if="getView == 'kanban'"
                  src="@/assets/images/kanban-icon-selected.svg"
                  alt="list-view-img"
                  :height="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  :width="$vuetify.breakpoint.xs ? '16px' : '19px'"
                />
                <img
                  v-else
                  src="@/assets/images/kanban-icon.svg"
                  alt="list-view-img"
                  :height="$vuetify.breakpoint.xs ? '16px' : '19px'"
                  :width="$vuetify.breakpoint.xs ? '16px' : '19px'"
                />
              </v-btn>
            </template>
            <span class="font-weight-bold dark-purple-text">Kanban View</span>
          </v-tooltip>
        </div>

        <div
          v-if="isExtension"
          @click="logout()"
          id="logout"
          class="pointer d-flex align-center py-4 pl-4 white--text"
        >
          <div>
            <v-icon size="30" class="white--text mr-1">mdi-logout</v-icon>
          </div>
        </div>

        <div
          v-if="
            $route && $route.path.slice(0, 5) == '/task' && getView == 'list'
          "
          class="d-flex align-center"
        >
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                v-on="on"
                v-bind="attrs"
                @click="mobileTasksColumns = true"
                class="
                  theme-border-3
                  d-flex
                  align-center
                  justify-center
                  pointer
                "
              >
                <v-icon
                  :class="
                    $vuetify.breakpoint.xs
                      ? 'white--text'
                      : 'dusty-purple-text '
                  "
                  >mdi-view-grid-plus-outline
                </v-icon>
              </div>
            </template>
            <span class="text-capitalize font-weight-bold dark-purple-text"
              >Customize columns</span
            >
          </v-tooltip>
          <div
            v-if="$vuetify.breakpoint.xs && $route && $route.path == '/task'"
            class="d-flex align-center"
          >
            <TaskFilters @openSidebar="filtersDrawer = !filtersDrawer" />
          </div>
        </div>

        <!-- Filters for calendar -->
        <div
          v-if="!isExtension && $route && $route.path == '/calendar'"
          class="d-flex align-center"
        >
          <!-- Title search -->
          <div
            v-if="!$vuetify.breakpoint.xs"
            style="height: 32px; min-width: 32px"
            @click="titleCalendar = !titleCalendar"
            class="
              d-flex
              align-center
              bg-white
              rounded
              justify-center
              mx-1
              theme-border
            "
          >
            <v-icon
              :class="titleField ? 'mx-2' : ''"
              class="align-center"
              size="20"
              color="#757096"
              >mdi-magnify</v-icon
            >
            <v-expand-transition>
              <input
                v-show="titleCalendar"
                id="title-search-field2"
                v-model="titleSearchCalendar"
                placeholder="Search title"
                autocomplete="off"
                color="white"
                class="body-2 title-search-field ma-0 pa-0"
                @blur="titleCalendar = false"
                type="text"
              />
            </v-expand-transition>
          </div>

          <CalendarFilters />
        </div>
        <!-- Action for team-members -->
        <div
          v-if="!isExtension && $route && $route.path == '/member'"
          class="d-flex align-center"
        >
          <v-icon
            :class="
              $vuetify.breakpoint.xs
                ? 'white--text theme-border-5'
                : 'dusty-purple-text theme-border-3'
            "
            class="align-center justify-center ml-1"
            @click="mobileTasksColumns = true"
            >mdi-view-grid-plus-outline
          </v-icon>
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="
                  getSelectedCompany.role == 'owner' ||
                  getSelectedCompany.role == 'admin'
                "
                depressed
                v-on="on"
                v-bind="attrs"
                light
                outlined
                color="white"
                :ripple="false"
                :style="
                  $vuetify.breakpoint.xs
                    ? ' min-width:26px; height:26px '
                    : 'min-width:32px; height:32px'
                "
                class="d-flex mx-1 align-center pa-0 justify-center"
                :class="
                  $vuetify.breakpoint.xs
                    ? 'white--text theme-border-5'
                    : 'dusty-purple-text theme-border-3'
                "
                @click="filtersDrawer = !filtersDrawer"
              >
                <v-icon
                  size="20"
                  class="ma-0 pa-0"
                  :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
                  >mdi-filter-outline</v-icon
                >
                <v-badge
                  class="ml-1 mb-5"
                  v-if="getMembersBadgedStatus"
                  color="red"
                  dot
                ></v-badge>
              </v-btn>
            </template>
            <span class="font-weight-bold dark-purple-text">Apply Filter</span>
          </v-tooltip>
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                light
                outlined
                color="white"
                :ripple="false"
                :style="
                  $vuetify.breakpoint.xs
                    ? ' min-width:26px; height:26px '
                    : 'min-width:32px; height:32px'
                "
                v-on="on"
                v-bind="attrs"
                class="outlined d-flex align-center pa-0 mx-1 justify-center"
                :class="
                  $vuetify.breakpoint.xs
                    ? 'white--text rounded theme-border-5'
                    : 'bg-white theme-border-3'
                "
                @click="dialog = true"
              >
                <v-icon
                  size="20"
                  class="align-center"
                  :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
                  >mdi-account-plus-outline</v-icon
                ></v-btn
              >
            </template>
            <span class="dark-purple-text font-weight-bold"
              >Add new member</span
            >
          </v-tooltip>
          <AddMember @close="dialog = false" :dialog.sync="dialog" />
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                light
                outlined
                color="white"
                :ripple="false"
                :style="
                  $vuetify.breakpoint.xs
                    ? ' min-width:26px; height:26px '
                    : 'min-width:32px; height:32px'
                "
                v-on="on"
                v-bind="attrs"
                class="d-flex align-center pa-0 mx-1 justify-center"
                :class="
                  $vuetify.breakpoint.xs
                    ? 'white--text rounded theme-border-5'
                    : 'bg-white theme-border-3'
                "
                @click="openProjectDialog = true"
              >
                <v-icon
                  size="20"
                  class="align-center"
                  :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
                  >mdi-text-box-plus-outline</v-icon
                ></v-btn
              >
            </template>
            <span class="dark-purple-text font-weight-bold"
              >Assign project</span
            >
          </v-tooltip>
          <template v-if="openProjectDialog">
            <AssignProject
              :projectDetails="projectDetails"
              :openProjectDialog.sync="openProjectDialog"
            />
          </template>
        </div>
        <!-- For Projects -->
        <div v-if="!isExtension && $route && $route.path == '/projects'">
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            color="#DCD8F3"
            content-class="arrow-up"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                light
                outlined
                color="white"
                :ripple="false"
                height="32px"
                min-width="32px"
                v-on="on"
                v-bind="attrs"
                class="
                  theme-border-3
                  d-flex
                  align-center
                  pa-0
                  mx-1
                  justify-center
                "
                :class="
                  $vuetify.breakpoint.xs ? 'white--text rounded' : 'bg-white'
                "
                @click="openProjectDialog = true"
              >
                <v-icon
                  size="20"
                  class="align-center"
                  :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
                  >mdi-text-box-plus-outline</v-icon
                ></v-btn
              >
            </template>
            <span class="dark-purple-text font-weight-bold"
              >Create project</span
            >
          </v-tooltip>
          <template v-if="openProjectDialog">
            <CreateProject
              :projectDetails="projectDetails"
              :openProjectDialog.sync="openProjectDialog"
            />
          </template>
        </div>
        <!-- Filters for Dashboard -->
        <div v-if="!isExtension && $route && $route.path == '/dashboard'">
          <v-btn
            depressed
            light
            outlined
            color="white"
            :ripple="false"
            min-width="32px"
            height="32px"
            class="theme-border-3 d-flex mx-1 align-center pa-0 justify-center"
            :class="$vuetify.breakpoint.xs ? 'white--text rounded' : 'bg-white'"
            @click="filtersDrawer = !filtersDrawer"
          >
            <v-icon
              size="20"
              class="ma-0 pa-0"
              :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
              >mdi-filter-outline</v-icon
            >
          </v-btn>
        </div>
        <!-- Filters for Reports -->
        <div v-if="!isExtension && $route && $route.path == '/reports'">
          <div class="d-flex">
            <v-icon
              :class="
                $vuetify.breakpoint.xs
                  ? 'white--text'
                  : 'dusty-purple-text theme-border-4'
              "
              class="theme-border-3 align-center justify-center mr-1"
              @click="mobileTasksColumns = true"
              >mdi-view-grid-plus-outline
            </v-icon>
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              ccolor="#DCD8F3"
              content-class="arrow-up"
              bottom
            >
            </v-tooltip>
            <!-- Filters button -->
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#DCD8F3"
              content-class="arrow-up"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  depressed
                  light
                  outlined
                  color="white"
                  :ripple="false"
                  min-width="32px"
                  height="32px"
                  class="
                    theme-border-3
                    d-flex
                    mx-1
                    align-center
                    pa-0
                    justify-center
                  "
                  :class="
                    $vuetify.breakpoint.xs ? 'white--text rounded' : 'bg-white'
                  "
                  @click="filtersDrawer = !filtersDrawer"
                >
                  <v-icon
                    size="20"
                    class="ma-0 pa-0"
                    :color="$vuetify.breakpoint.xs ? 'white' : '#757096'"
                    >mdi-filter-outline</v-icon
                  >
                  <v-badge
                    class="mb-5"
                    v-if="getBadgedReportsStatus"
                    color="red"
                    dot
                  ></v-badge>
                </v-btn>
              </template>
              <span class="font-weight-bold dark-purple-text"
                >Apply Filter</span
              >
            </v-tooltip>
          </div>
          <ReportsFiltersSidebar
            v-if="$route.path == '/reports'"
            :drawer.sync="filtersDrawer"
          />
        </div>
        <CompaniesList class="ml-1" />
      </v-app-bar>
    </v-app>
    <!-- Snackbar -->
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <DashboardFiltersSidebar
      v-if="$route.path == '/dashboard'"
      :drawer.sync="filtersDrawer"
    />
    <FiltersSidebar
      v-if="$route.path.slice(0, 5) == '/task'"
      :drawer.sync="filtersDrawer"
    />
    <MembersFilterSidebar
      v-if="$route.path == '/member'"
      :drawer.sync="filtersDrawer"
    />

    <MobileTaskColumns
      v-if="
        $route.path == '/task' ||
        $route.path == '/member' ||
        $route.path == '/reports'
      "
      :drawer.sync="mobileTasksColumns"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import timer from "@/timer";
import { eventBus } from "@/main";
import _ from "lodash";
import Swal from "sweetalert2";
export default {
  name: "Sidebar",
  components: {
    CompaniesList: () => import("@/components/Companies/CompaniesList.vue"),
    profileimage: () => import("@/components/Includes/ProfileImage"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
    TaskFilters: () => import("@/components/Tasks/TaskFilters"),
    FiltersSidebar: () => import("@/components/Tasks/FiltersSidebar"),
    MobileTaskColumns: () =>
      import("@/components/Tasks/MobileView/MobileTaskColumns"),

    DashboardFiltersSidebar: () =>
      import("@/components/Dashboard/DashboardFiltersSidebar"),
    CalendarFilters: () =>
      import("@/components/Tasks/CalendarView/CalendarFilters"),
    AddMember: () => import("@/components/TeamMembers/AddMember"),
    AssignProject: () => import("@/components/TeamMembers/AssignProject"),
    CreateProject: () => import("@/components/Projects/CreateProject"),
    MembersFilterSidebar: () =>
      import("@/components/TeamMembers/MembersFilterSidebar"),
    ReportsFiltersSidebar: () =>
      import("@/components/Reports/ReportsFiltersSidebar"),
  },
  mixins: [snackbarMixin],
  props: ["flag"],
  data() {
    return {
      filtersXSMenu: false,
      projectDetails: null,
      openProjectDialog: false,
      dialog: false,
      filtersDrawer: false,
      titleField: false,
      titleCalendar: false,
      mobileTasksColumns: false,
      drawer: false,
      selectedCompany: null,
      titleSearchQuery: null,
      titleSearchCalendar: null,
      userName: "",
      title: "",
      mini: this.$vuetify.breakpoint.xs ? false : true,
      // Router links Array
      links: [
        {
          icon: "mdi-note-plus-outline",
          text: "Create Task",
          route: "/mobileTasks",
        },
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          route: "/dashboard",
        },
        {
          icon: "mdi-clock-fast",
          text: "Task Tracker",
          route: "/task",
        },
        {
          icon: "mdi-calendar",
          text: "Calendar",
          route: "/calendar",
        },
        {
          icon: "mdi-account-supervisor-outline",
          text: "Team Members",
          route: "/member",
        },
        {
          icon: "mdi-text-box-plus-outline",
          text: "Projects",
          route: "/projects",
        },
        {
          icon: "mdi-chart-line",
          text: "Reports",
          route: "/reports",
        },
        {
          icon: "mdi-cog",
          text: "Settings",
          route: "/companysettings",
        },
        {
          icon: "mdi-shopping-outline",
          text: "Billing",
          route: "/billing",
        },
      ],
      linksCopy: [
        {
          icon: "mdi-note-plus-outline",
          text: "Create Task",
          route: "/mobileTasks",
        },
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          route: "/dashboard",
        },
        {
          icon: "mdi-clock-fast",
          text: "Task Tracker",
          route: "/task",
        },
        {
          icon: "mdi-calendar",
          text: "Calendar",
          route: "/calendar",
        },
        {
          icon: "mdi-account-supervisor-outline",
          text: "Team Members",
          route: "/member",
        },
        {
          icon: "mdi-text-box-plus-outline",
          text: "Projects",
          route: "/projects",
        },
        {
          icon: "mdi-chart-line",
          text: "Reports",
          route: "/reports",
        },
        {
          icon: "mdi-cog",
          text: "Settings",
          route: "/companysettings",
        },
        {
          icon: "mdi-shopping-outline",
          text: "Billing",
          route: "/billing",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getSelectedCompany",
      "getTime",
      "getActiveTask",
      "getTimer",
      "getPendingTimer",
      "getOnlineStatus",
      "getScreenRecorderState",
      "getSidebarMini",
      "getView",
      "getExtension",
      "getSearchedTitle",
      "getTaskTitleFilter",
      "getCalendarTitle",
      "getReportsView",
      "getBadgedReportsStatus",
      "getMembersBadgedStatus",
      "getReportsSearchQuery",
    ]),
    role() {
      return this.getSelectedCompany ? this.getSelectedCompany.role : null;
    },
    time() {
      return timer.format(this.getTimer);
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    getLoggedInUserName() {
      var userName = this.getLoggedInUser.name;
      if (userName) {
        userName = userName.split(" ");
        if (userName.length >= 3) {
          userName =
            userName[0].charAt(0) +
            " " +
            userName[1].charAt(0) +
            " " +
            userName[2];

          return userName;
        } else {
          return this.getLoggedInUser.name;
        }
      }
      return this.getLoggedInUser.email;
    },
    currentRouteName() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions(["selectCompany"]),
    listView() {
      this.$store.commit("setTaskFilter", {
        assigned_by: [],
        assigned_to: [],
        project_id: [],
        page: 1,
      });
      this.$store.commit("setView", "list");
      eventBus.$emit("setResetFilter");
    },
    resetFilters() {
      if (this.$route.path != "/task") this.$router.push({ name: "task" });
      this.$store.commit("setTaskFilter", {
        assigned_by: [],
        assigned_to: [],
        project_id: [],
        page: 1,
      });
      this.titleSearchQuery = null;
      this.titleSearchCalendar = null;
      this.$store.commit("setKanbanTaskTitleFilter", null);
      eventBus.$emit("setResetFilter");
    },
    setKanbanView() {
      if (!this.isExtension) {
        if (
          this.getSelectedCompany.subscribed_plan &&
          this.getSelectedCompany.subscribed_plan.toLowerCase() != "basic"
        ) {
          this.$store.commit("setView", "kanban");
        } else {
          let dialogData = {
            title: "Sorry for Inconvenience",
            icon: "warning",
            showCancelButton: true,
            reverseButtons: true,
          };
          if (
            this.getSelectedCompany.role == "admin" ||
            this.getSelectedCompany.role == "owner"
          ) {
            dialogData["html"] =
              "Please upgrade your plan to use this feature ";
            dialogData["cancelButtonText"] = "Cancel";
            dialogData["confirmButtonText"] = "Update";
          } else {
            dialogData["html"] =
              "Sorry you can't use this feature please contact your company admin";
            dialogData["cancelButtonText"] = "Ok";
            dialogData["showConfirmButton"] = false;
          }
          Swal.fire(dialogData).then((result) => {
            if (result.value) {
              this.$router.push("/billing");
            }
          });
        }
      } else {
        this.$store.commit("setView", "list");
      }
    },
    searchTitle() {
      if (this.getView == "kanban") {
        this.$store.commit("setKanbanTaskTitleFilter", this.titleSearchQuery);
        this.$store.dispatch("fetchKanbanTasks", "pending");
        this.$store.dispatch("fetchKanbanTasks", "completed");
        this.$store.dispatch("fetchKanbanTasks", "active");
      } else if (this.getView == "list") {
        this.$store.commit("setTaskFilter", { title: this.titleSearchQuery });
      }
    },
    redirect(link) {
      if (this.$vuetify.breakpoint.xs) this.drawer = false;
      if (link.text == "Task Tracker") {
        if (this.title != "Task Tracker") {
          this.$store.commit("setFlagged", {
            flagged: "All",
          });
          //this.$store.commit("resetTaskFilters");
          this.$store.dispatch("updateTaskCategory");

          this.$router.push({ path: link.route });
        } else {
          this.$store.commit("setFlagged", {
            flagged: "All",
          });
          //this.$store.commit("resetTaskFilters");
          this.$store.dispatch("updateTaskCategory");

          this.$store.commit("setKanbanTaskTitleFilter", "");

          if (this.getView == "list") this.$store.dispatch("fetchTasks");
          if (this.getView == "kanban") {
            this.$store.dispatch("fetchKanbanTasks", "pending");
            this.$store.dispatch("fetchKanbanTasks", "active");
            this.$store.dispatch("fetchKanbanTasks", "completed");
          }
        }
      } else if (link.text == "Calendar") {
        if (this.title != "Calendar") {
          this.$store.commit("resetCalendarFilter");
          this.$router.push({ path: link.route });
        } else {
          this.$store.commit("resetCalendarFilter");
        }
      } else {
        this.$route.path != link.route
          ? this.$router.push({ path: link.route })
          : () => {};
      }
    },
    // Toggle sidebar
    toggleMini() {
      this.mini = !this.mini;
      this.$store.commit("setSidebarMini", this.mini);
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    extension() {
      window.open(
        "https://chrome.google.com/webstore/detail/gigs-timer/cimhmkfhdmcnneknggkhbdcefhimjdgo/related?hl=en",
        "_blank"
      );
    },
    logout() {
      if (this.getActiveTask) {
        this.openSnackbar(true, "Please stop your task");
      } else {
        window.document.title = "task timer";
        this.getActiveTask ? this.$store.dispatch("stopTask") : () => {};
        localStorage.removeItem("new-comment");
        this.$store.dispatch("updateTaskCategory").then(() => {
          this.$store.commit("setEmptyMembersArray", []);
          this.$store.dispatch("logout");
        });
      }
    },
  },
  watch: {
    closeDrawer(value) {
      this.drawer = value;
    },
    // clear search query for list
    getSearchedTitle(value) {
      if (!value) {
        this.titleSearchQuery = value;
        this.titleSearchCalendar = value;
      }
    },
    // clear search query for kanban
    getTaskTitleFilter(value) {
      if (!value) {
        this.titleSearchQuery = value;
        this.titleSearchCalendar = value;
      }
    },
    // clear search query for calendar
    getCalendarTitle(value) {
      if (!value) {
        this.titleSearchQuery = value;
        this.titleSearchCalendar = value;
      }
    },
    titleField(value) {
      if (value) {
        setTimeout(() => {
          document.getElementById("title-search-field").focus();
        }, 100);
      }
    },
    titleCalendar(value) {
      if (value) {
        setTimeout(() => {
          document.getElementById("title-search-field2").focus();
        }, 100);
      }
    },
    titleSearchQuery: {
      handler: _.debounce(function () {
        this.searchTitle();
      }, 1000),
      deep: true,
    },
    titleSearchCalendar: {
      handler: _.debounce(function (value) {
        this.$store.commit("setCalendarTaskFilter", { title: value });
      }, 1000),
      deep: true,
    },
    role(value) {
      this.links = [...this.linksCopy];
      if (!(value == "owner" || value == "team-manager" || value == "admin")) {
        this.links = this.links.filter((item) => {
          return item.route != "/member";
        });
        if (this.$route.name == "member") {
          this.$router.push({ name: "task" });
        }
      }
      if (!(value == "owner" || value == "admin")) {
        this.links = this.links.filter((item) => {
          return item.route != "/projects" && item.route != "/billing";
        });
        if (this.$route.name == "projects") {
          this.$router.push({ name: "task" });
        }
      } else {
        this.links = [
          {
            icon: "mdi-note-plus-outline",
            text: "Create Task",
            route: "/mobileTasks",
          },
          {
            icon: "mdi-view-dashboard",
            text: "Dashboard",
            route: "/dashboard",
          },
          {
            icon: "mdi-clock-fast",
            text: "Task Tracker",
            route: "/task",
          },
          {
            icon: "mdi-calendar-outline",
            text: "Calendar",
            route: "/calendar",
          },
          {
            icon: "mdi-account-supervisor-outline",
            text: "Team Members",
            route: "/member",
          },
          {
            icon: "mdi-text-box-plus-outline",
            text: "Projects",
            route: "/projects",
          },
          {
            icon: "mdi-chart-line",
            text: "Reports",
            route: "/reports",
          },
          {
            icon: "mdi-cog",
            text: "Settings",
            route: "/companysettings",
          },
          {
            icon: "mdi-shopping-outline",
            text: "Billing",
            route: "/billing",
          },
        ];
      }
    },
    getSelectedCompany(value) {
      this.links = [...this.linksCopy];
      if (
        value &&
        !(
          value.role == "owner" ||
          value.role == "team-manager" ||
          value.role == "admin"
        )
      ) {
        this.links = this.links.filter((item) => {
          return item.route != "/member";
        });
      }
      if (value && !(value.role == "owner" || value.role == "admin")) {
        this.links = this.links.filter((item) => {
          return item.route != "/projects" && item.route != "/billing";
        });
      } else {
        this.links = [
          {
            icon: "mdi-note-plus-outline",
            text: "Create Task",
            route: "/mobileTasks",
          },
          {
            icon: "mdi-view-dashboard",
            text: "Dashboard",
            route: "/dashboard",
          },
          {
            icon: "mdi-clock-fast",
            text: "Task Tracker",
            route: "/task",
          },
          {
            icon: "mdi-calendar-outline",
            text: "Calendar",
            route: "/calendar",
          },
          {
            icon: "mdi-account-supervisor-outline",
            text: "Team Members",
            route: "/member",
          },

          {
            icon: "mdi-text-box-plus-outline",
            text: "Projects",
            route: "/projects",
          },
          {
            icon: "mdi-chart-line",
            text: "Reports",
            route: "/reports",
          },
          {
            icon: "mdi-cog",
            text: "Settings",
            route: "/companysettings",
          },
          {
            icon: "mdi-shopping-outline",
            text: "Billing",
            route: "/billing",
          },
        ];
      }
    },
    $route(value) {
      this.title = value.meta.title;
    },
    getView(value, oldValue) {
      if (oldValue != value) {
        this.titleSearchQuery = null;
        this.titleSearchCalendar = null;
      }
    },
    // Watcher for breakpoint, when screen hits the
    // large or small screen. Navigation drawer will get open
    breakpoint(value) {
      if (value == "md" || value == "sm" || value == "xs") {
        this.mini = true;
        this.$store.commit("setSidebarMini", true);
      }
    },
  },
  mounted() {
    if (this.$route.path == "/task") {
      this.titleSearchQuery = this.getTaskTitleFilter;
    }
    eventBus.$on("companySwitched", () => {
      this.titleSearchQuery = null;
      this.titleSearchCalendar = null;
    });
    if (
      !(
        this.role == "owner" ||
        this.role == "team-manager" ||
        this.role == "admin"
      )
    ) {
      this.links = this.links.filter((item) => {
        return item.route != "/member";
      });
    }
    if (!(this.role == "owner" || this.role == "admin")) {
      this.links = this.links.filter((item) => {
        return item.route != "/projects" && item.route != "/billing";
      });
    } else {
      this.links = [
        {
          icon: "mdi-note-plus-outline",
          text: "Create Task",
          route: "/mobileTasks",
        },
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          route: "/dashboard",
        },
        {
          icon: "mdi-clock-fast",
          text: "Task Tracker",
          route: "/task",
        },
        {
          icon: "mdi-calendar-outline",
          text: "Calendar",
          route: "/calendar",
        },
        {
          icon: "mdi-account-supervisor-outline",
          text: "Team Members",
          route: "/member",
        },
        {
          icon: "mdi-text-box-plus-outline",
          text: "Projects",
          route: "/projects",
        },
        {
          icon: "mdi-chart-line",
          text: "Reports",
          route: "/reports",
        },
        {
          icon: "mdi-cog",
          text: "Settings",
          route: "/companysettings",
        },
        {
          icon: "mdi-shopping-outline",
          text: "Billing",
          route: "/billing",
        },
      ];
    }
    // Mini variant by default
    this.$store.commit("setSidebarMini", true);
    //Return selected Route title on click
    let link = this.links.find((item) => {
      return item.route == this.$route.path;
    });
    if (link) {
      this.title = link.text;
    } else if (this.$route.path.includes("task")) {
      this.title = "Task Tracker";
    }
  },
  beforeDestroy() {
    eventBus.$off("companySwitched");
  },
};
</script>
<style scoped>
.toggler {
  position: absolute;
  left: -15px;
  top: 20px;
  z-index: 9999;
  background-color: #2a206a !important;
  border: solid white 1.8px;
  height: 30px;
  width: 30px;
}
.selected-route {
  border-left: 2px solid #1cc283 !important;
  background-color: #a49fc781;
}
.selected-view {
  background-color: #dcd8f3 !important;
}
.xs-screen-view {
  background-color: #e5e4eb !important;
}
.title-search-field {
  height: 30px !important;
  width: 280px;
}

.border-circle {
  border-radius: 30px;
}
.top-bar-elevation {
  box-shadow: 0 2px 4px 0 rgba(212, 212, 212, 0.5) !important;
}
.max-height-sidebar {
  max-height: 70%;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
.max-height-sidebar::-webkit-scrollbar {
  display: none;
}
</style>
